var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-panel"},[_c('div',{staticClass:"top-block"},[_vm._t("top")],2),_c('div',{staticClass:"middle-block"},[_c('ScrollShadow',[_vm._t("center")],2)],1),_c('div',{staticClass:"bottom-block"},[_vm._t("bottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }